<template>
    <ul>
        <li v-for="(item, i) in getMenuFun" v-bind:key="i">
          <router-link v-bind:to="item.path" active-class="active" v-bind:class="item.cl" v-if="eventid[item.eid]!==undefined||item.eid=='0'">
            <i v-bind:class="[item.class ? item.class : '',item.icon]"></i> {{ item.name }}
          </router-link>
        </li>
    </ul>
</template>
<script>
export default {
  name: 'app',
  data () {
    return {eventsData:null }
  },
  computed: {
    getMenuFun:function(){
      return this.$store.getters.menuData
    },
     eventid() {
      this.eventsData= JSON.parse(localStorage.getItem("eventids"));
       return this.eventsData
    },
    
  },
  title () { return '' }
}
</script>



// WEBPACK FOOTER //
// src/components/Submenu.vue